import { render, staticRenderFns } from "./topic-select-dialog.vue?vue&type=template&id=78b6c53c&scoped=true"
import script from "./topic-select-dialog.vue?vue&type=script&lang=ts"
export * from "./topic-select-dialog.vue?vue&type=script&lang=ts"
import style0 from "./topic-select-dialog.vue?vue&type=style&index=0&id=78b6c53c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6c53c",
  null
  
)

export default component.exports